import TagManager from 'react-gtm-module';

export const initTagManager = ({ googleTagManagerId }) => {
  TagManager.initialize({
    gtmId: googleTagManagerId,
  });
};
